export const EVENT_STATUS = {
	INACTIVE: 'INACTIVE',
	ACTIVE: 'ACTIVE',
};

export const SINGLE_PAGE_APP = {
	TRUE: 'TRUE',
	FALSE: 'FALSE',
};

export const ANONYMOUS_LOGIN = {
	TRUE: 'TRUE',
	FALSE: 'FALSE',
};

export const ACTIVE_HOMESCREEN = {
	STANDARD: 'STANDARD',
	WIDGET: 'WIDGET',
};

export const RECURRING_TIME_TYPE = {
	NOT_RECURRING: 'NOT_RECURRING',
	DAILY: 'DAILY',
	WEEKLY: 'WEEKLY',
	MONTHLY: 'MONTHLY',
	YEARLY: 'YEARLY',
	HOURLY: 'HOURLY',
};

export const EVENT_ADMIN_CONTRIBUTOR_TYPES = {
	AGENDA: 'Agenda',
	ANALYTICS: 'Analytics Report',
	APP_DESIGN: 'App Layout / Content',
	ATTENDEES: 'People / Groups',
	ANNOUNCEMENTS: 'Push Announcements',
	SOCIAL_FEED: 'Social Engagement',
	PLUGINS: 'Live Features',
};
